"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;
var _logo = _interopRequireDefault(require("../logo"));
var appStyle = require("./app_css.js")["default"];
var style = require("./template_css.js")["default"];
function template() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp,
    children = p.children,
    _p$footerMenu = p.footerMenu,
    footerMenu = _p$footerMenu === void 0 ? [{
      name: "HOME",
      href: "/"
    }, {
      name: "404",
      href: "/404"
    }, {
      name: "500",
      href: "/500"
    }, {
      name: "EXTERNAL",
      href: "https://google.com",
      target: "_blank"
    }] : _p$footerMenu,
    _p$logo = p.logo,
    logo = _p$logo === void 0 ? _logo["default"] : _p$logo;
  var styles = wapp.styles;
  var _wapp$config$siteName = wapp.config.siteName,
    siteName = _wapp$config$siteName === void 0 ? "Wapplr" : _wapp$config$siteName;
  var copyright = "".concat(siteName, " ").concat(new Date().getFullYear(), " \xA9");
  var serverRender = typeof window === "undefined";
  styles.use(appStyle);
  styles.use(style);
  return "\n            <div class=\"".concat(style.page, "\">\n                <header class=\"").concat(style.header, "\">\n                    <div class=\"").concat(style.innerHeader, "\">\n                        <div class=\"").concat(style.logo, "\">\n                            ").concat(logo({
    wapp: wapp
  }), "\n                        </div>\n                    </div>\n                </header>\n                <main class=\"").concat(style.content, "\">").concat(children, "</main>\n                <footer class=\"").concat(style.footer, "\">\n                    <div>\n                        <div class=\"").concat(style.menu, "\">\n                            ").concat(footerMenu.map(function (menu) {
    var target = menu.target || "self";
    var noreferrer = target === "_blank" ? ' rel="noreferrer"' : "";
    return '<div><a class="' + style.button + '"  target="' + target + '" href="' + menu.href + '" wapplronclicklistener=""' + noreferrer + '>' + menu.name + '</a></div>';
  }).join(""), "\n                        </div>\n                        <div class=\"").concat(style.copyright, "\">\n                            ").concat(copyright, "\n                        </div>\n                    </div>\n                </footer>\n                <script>\nif (").concat(!serverRender, "){\n    window.addEventListener(\"scroll\", function (e) {\n        const header = document.querySelector(\".").concat(style.header, "\");\n        if (header){\n            header.classList.toggle(\"").concat(style.sticky, "\", window.scrollY > 0 )\n        }\n    })\n}\n                </script>\n            </div>");
}